// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__f6zZw","header":"PatientBlock_header__cVShO","label":"PatientBlock_label__3CNno","option":"PatientBlock_option__3-XNT"};